import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Config } from '../.env.js';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useLocation } from "react-router-dom";


const CampaignForm = () => {
    const [AuthName, setAuthName] = useState('');
    const [AuthContact, setAuthContact] = useState('');
    const [AuthEmail, setAuthEmail] = useState('');
    const [brandName, setBrandName] = useState('');
    const [users, setUsers] = useState([]);
    const [brandLogo, setBrandLogo] = useState(null);
    const [brandLogoPreview, setBrandLogoPreview] = useState(null);

    const [quillError, setQuillError] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();


    const location = useLocation();

    useEffect(() => {
        if (location.state && location.state.campaign) {
            const { campaign } = location.state;

            // Pre-fill fields
            setBrandName(campaign.brandName || "");
            setAuthName(campaign.name || "");
            setAuthContact(campaign.campaignName || "");
            setAuthEmail(campaign.campaignRulesDescription || "");

            // If brand logo exists, set preview
            if (campaign.brandLogo) {
                setBrandLogoPreview(`${Config.API_URL}/${campaign.brandLogo}`);
            }

            // Pre-select managers & leads
            if (campaign.managers || campaign.leads) {
                setUsers((prevUsers) =>
                    prevUsers.map((user) => ({
                        ...user,
                        isChecked:
                            (campaign.managers || []).includes(user.yourName) ||
                            (campaign.leads || []).includes(user.yourName),
                    }))
                );
            }
        }
    }, [location.state]);


    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await fetch(`${Config.API_URL}/api/getUsersmangerleads`);
                if (!response.ok) throw new Error('Failed to fetch users');
                const usersData = await response.json();
                console.log("Fetched users:", usersData); // 🟡 Add this line
                setUsers(usersData);
            } catch (error) {
                console.error('Error fetching users:', error);
            }
        };

        fetchUsers();
    }, []);


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const plainText = AuthEmail.replace(/<(.|\n)*?>/g, '').trim();
        if (plainText.length === 0) {
            setQuillError(true);
            setLoading(false);
            return;
        }

        const managers = users
            .filter(user => user.role === 'Campaign_Manger' && user.isChecked && user.yourName)
            .map(user => user.yourName);

        const leads = users
            .filter(user => user.role === 'Lead' && user.isChecked && user.yourName)
            .map(user => user.yourName);

        const formData = new FormData();
        formData.append('brandName', brandName);
        formData.append('name', AuthName);
        formData.append('campaignName', AuthContact);
        formData.append('campaignRulesDescription', AuthEmail);
        formData.append('managers', JSON.stringify(managers));
        formData.append('leads', JSON.stringify(leads));

        if (brandLogo) {
            formData.append('brandLogo', brandLogo);
        }

        try {
            const response = await axios.post(`${Config.API_URL}/api/campaigns`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            const { id } = response.data.campaign;
            navigate('/campaign2', { state: { id, campaignName: AuthContact, managers, brandName } });
        } catch (error) {
            console.error('Error submitting form', error);
        } finally {
            setLoading(false);
        }
    };


    // const handleCheckboxChange = (id) => (event) => {
    //     const updatedUsers = users.map(user =>
    //         user._id === id ? { ...user, isChecked: event.target.checked } : user
    //     );
    //     setUsers(updatedUsers);
    //     localStorage.setItem('users', JSON.stringify(updatedUsers));
    // };
    const handleCheckboxChange = (id) => (event) => {
        const updatedUsers = users.map(user =>
            user._id === id ? { ...user, isChecked: event.target.checked } : user
        );
        console.log("Updated users:", updatedUsers); // 🟡 Add this
        setUsers(updatedUsers);
        localStorage.setItem('users', JSON.stringify(updatedUsers));
    };

    const isQuillContentEmpty = (content) => {
        const plainText = content.replace(/<(.|\n)*?>/g, '').replace(/&nbsp;|\s/g, '').trim();
        return plainText.length === 0;
    };

    const handleChange = (value) => {
        setAuthEmail(value);
        localStorage.setItem('AuthEmail', value);

        if (!isQuillContentEmpty(value)) {
            setQuillError(false);
        }
    };

    // const handleChange = (value) => {
    //     setAuthEmail(value);
    //     localStorage.setItem('AuthEmail', value);
    //     if (value.replace(/<(.|\n)*?>/g, '').trim().length > 0) {
    //         setQuillError(false);
    //     }
    // };

    const handleInputChange = (e, setter, storageKey) => {
        const value = e.target.value;
        setter(value);
        localStorage.setItem(storageKey, value);
    };

    return (
        <div className='container'>
            {loading && (
                <div className="loader-overlay">
                    <div className="loader"></div>
                </div>
            )}
            <form onSubmit={handleSubmit}>
                <div className="field">
                    <h1 className='title has-text-centered mt-5'>Campaign</h1>
                </div>

                <div className='field is-small'>
                    <label className="label has-text-left">Brand Name*</label>
                    <div className="control">
                        <input
                            className="input is-rounded"
                            type="text"
                            placeholder="Brand Name"
                            value={brandName}
                            onChange={(e) => handleInputChange(e, setBrandName, 'brandName')}
                            required
                        />
                    </div>
                </div>
                <div className="field is-small">
                    <label className="label has-text-left">Brand Logo (600×600 max)*</label>
                    <div className="control">
                        <input
                            className="input"
                            type="file"
                            accept="image/png, image/jpeg, image/jpg"
                            onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                    setBrandLogo(file);
                                    const reader = new FileReader();
                                    reader.onloadend = () => {
                                        setBrandLogoPreview(reader.result);
                                    };
                                    reader.readAsDataURL(file);
                                }
                            }}
                        />
                    </div>
                    {brandLogoPreview && (
                        <div style={{ marginTop: "10px" }}>
                            <p className="has-text-weight-semibold">Preview:</p>
                            <img
                                src={brandLogoPreview}
                                alt="Brand Logo Preview"
                                style={{ maxWidth: "150px", maxHeight: "150px", border: "1px solid #ccc", borderRadius: "8px" }}
                            />
                        </div>
                    )}
                </div>

                <div className='field is-small'>
                    <label className="label has-text-left">Campaign Name*</label>
                    <div className="control">
                        <input
                            className="input is-rounded"
                            type="text"
                            placeholder="Campaign Name"
                            value={AuthContact}
                            onChange={(e) => handleInputChange(e, setAuthContact, 'AuthContact')}
                            required
                        />
                    </div>
                </div>

                <div className='field'>
                    <label className="label has-text-left">Campaign Rules Description*</label>
                    <div className="control">
                        <ReactQuill
                            value={AuthEmail}
                            onChange={handleChange}
                            placeholder="Campaign rule description"
                            modules={{
                                toolbar: [
                                    [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
                                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                    ['bold', 'italic', 'underline'],
                                    [{ 'align': [] }],
                                    ['link'],
                                    ['blockquote'],
                                    [{ 'script': 'sub' }, { 'script': 'super' }],
                                    ['code'],
                                    [{ 'indent': '-1' }, { 'indent': '+1' }],
                                    ['clean']
                                ],
                            }}
                            style={{ borderRadius: "20px", border: quillError ? '1px solid red' : undefined }}
                        />
                        {quillError && (
                            <p className="has-text-danger" style={{ fontSize: "0.85rem" }}>
                                Campaign rules description is required.
                            </p>
                        )}
                    </div>
                </div>

                <div className='field'>
                    <label className="label has-text-left"><strong>Choose Your Campaign Manager(s)</strong></label>
                    <div className="control column">
                        {users.filter(user => user.role === 'Campaign_Manger').map(user => (
                            <div key={user._id} className="checkboxContainer" style={{ display: 'inline-flex', flexDirection: 'row', marginRight: '8px' }}>
                                <input
                                    type="checkbox"
                                    checked={user.isChecked || false}
                                    onChange={handleCheckboxChange(user._id)}
                                    className="checkbox"
                                />
                                <label className="checkboxLabel" style={{ marginLeft: '8px' }}>{user.yourName}</label>
                            </div>
                        ))}
                    </div>
                </div>

                <div className='field'>
                    <label className="label has-text-left"><strong>Choose Your Lead(s)</strong></label>
                    <div className="control column">
                        {users.filter(user => user.role === 'Lead').map(user => (
                            <div key={user._id} className="checkboxContainer" style={{ display: 'inline-flex', flexDirection: 'row', marginRight: '9px' }}>
                                <input
                                    type="checkbox"
                                    checked={user.isChecked || false}
                                    onChange={handleCheckboxChange(user._id)}
                                    className="checkbox"
                                />
                                <label className="checkboxLabel" style={{ marginLeft: '8px' }}>{user.yourName}</label>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="field">
                    <div className="control">
                        <button className="button is-primary is-fullwidth mt-5 is-rounded" type="submit">
                            {loading ? (
                                <div className="loader"></div>
                            ) : (
                                'Submit'
                            )}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default CampaignForm;

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import { Config } from '../.env.js';
// import ReactQuill from 'react-quill';
// import 'react-quill/dist/quill.snow.css';

// const CampaignForm = () => {
//     const [AuthName, setAuthName] = useState('');
//     const [AuthContact, setAuthContact] = useState('');
//     const [AuthEmail, setAuthEmail] = useState('');
//     const [brandName, setBrandName] = useState('');
//     const [reviewType, setReviewType] = useState('');
//     const [users, setUsers] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const navigate = useNavigate();

//     useEffect(() => {
//         const fetchUsers = async () => {
//             try {
//                 const response = await fetch(`${Config.API_URL}/api/users`);
//                 if (!response.ok) throw new Error('Failed to fetch users');
//                 const usersData = await response.json();
//                 setUsers(usersData);
//             } catch (error) {
//                 console.error('Error fetching users:', error);
//             }
//         };

//         fetchUsers();

//         // Load from localStorage
//         const savedBrandName = localStorage.getItem('brandName');
//         const savedAuthName = localStorage.getItem('AuthName');
//         const savedAuthContact = localStorage.getItem('AuthContact');
//         const savedAuthEmail = localStorage.getItem('AuthEmail');
//         const savedReviewType = localStorage.getItem('reviewType');
//         const savedUsers = JSON.parse(localStorage.getItem('users'));

//         if (savedBrandName) setBrandName(savedBrandName);
//         if (savedAuthName) setAuthName(savedAuthName);
//         if (savedAuthContact) setAuthContact(savedAuthContact);
//         if (savedAuthEmail) setAuthEmail(savedAuthEmail);
//         if (savedReviewType) setReviewType(savedReviewType);
//         if (savedUsers) setUsers(savedUsers);
//     }, []);

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);

//         const managers = users.filter(user => user.role !== 'Lead' && user.isChecked).map(user => user.userName);
//         const leads = users.filter(user => user.role === 'Lead' && user.isChecked).map(user => user.userName);

//         const formData = {
//             brandName,
//             name: AuthName,
//             campaignName: AuthContact,
//             campaignRulesDescription: AuthEmail,
//             managers,
//             leads,
//             reviewType
//         };

//         try {
//             const response = await axios.post(`${Config.API_URL}/api/campaigns`, formData);
//             const { id } = response.data.campaign;
//             navigate('/campaign2', { state: { id, campaignName: AuthContact, managers } });
//         } catch (error) {
//             console.error('Error submitting form', error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleCheckboxChange = (id) => (event) => {
//         const updatedUsers = users.map(user =>
//             user._id === id ? { ...user, isChecked: event.target.checked } : user
//         );
//         setUsers(updatedUsers);
//         localStorage.setItem('users', JSON.stringify(updatedUsers));
//     };

//     const handleChangeDescription = (value) => {
//         setAuthEmail(value);
//         localStorage.setItem('AuthEmail', value);
//     };

//     const handleInputChange = (e, setter, storageKey) => {
//         const value = e.target.value;
//         setter(value);
//         localStorage.setItem(storageKey, value);
//     };

//     return (
//         <div className='container'>
//             {loading && (
//                 <div className="loader-overlay">
//                     <div className="loader"></div>
//                 </div>
//             )}
//             <form onSubmit={handleSubmit}>
//                 <h1 className='title has-text-centered mt-5'>Create Campaign</h1>

//                 <div className='field'>
//                     <label className="label">Brand Name*</label>
//                     <div className="control">
//                         <input
//                             className="input is-rounded"
//                             type="text"
//                             placeholder="Brand Name"
//                             value={brandName}
//                             onChange={(e) => handleInputChange(e, setBrandName, 'brandName')}
//                             required
//                         />
//                     </div>
//                 </div>

//                 <div className='field'>
//                     <label className="label">Campaign Name*</label>
//                     <div className="control">
//                         <input
//                             className="input is-rounded"
//                             type="text"
//                             placeholder="Campaign Name"
//                             value={AuthContact}
//                             onChange={(e) => handleInputChange(e, setAuthContact, 'AuthContact')}
//                             required
//                         />
//                     </div>
//                 </div>

//                 <div className='field'>
//                     <label className="label">Campaign Rules Description*</label>
//                     <ReactQuill
//                         value={AuthEmail}
//                         onChange={handleChangeDescription}
//                         placeholder="Enter campaign rules"
//                         modules={{
//                             toolbar: [
//                                 [{ 'header': '1' }, { 'header': '2' }],
//                                 [{ 'list': 'ordered' }, { 'list': 'bullet' }],
//                                 ['bold', 'italic', 'underline'],
//                                 [{ 'align': [] }],
//                                 ['link'],
//                                 ['clean']
//                             ]
//                         }}
//                         style={{ borderRadius: "10px" }}
//                     />
//                 </div>

//                 <div className='field'>
//                     <label className="label">Review Type*</label>
//                     <div className="control">
//                         <div className="select is-rounded is-fullwidth">
//                             <select
//                                 name="reviewType"
//                                 value={reviewType}
//                                 onChange={(e) => {
//                                     setReviewType(e.target.value);
//                                     localStorage.setItem('reviewType', e.target.value);
//                                 }}
//                                 required
//                             >
//                                 <option value="">Select Review Type</option>
//                                 <option value="Google Review">Google Review</option>
//                                 <option value="Amazon Review">Amazon Review</option>
//                                 <option value="YouTube Review">YouTube Review</option>
//                             </select>
//                         </div>
//                     </div>
//                 </div>

//                 <div className='field'>
//                     <label className="label">Campaign Manager(s)*</label>
//                     {users.filter(user => user.role !== 'Lead').map(user => (
//                         <label key={user._id} className="checkbox mr-3">
//                             <input
//                                 type="checkbox"
//                                 checked={user.isChecked || false}
//                                 onChange={handleCheckboxChange(user._id)}
//                             />
//                             <span className='ml-2'>{user.userName}</span>
//                         </label>
//                     ))}
//                 </div>

//                 <div className='field'>
//                     <label className="label">Campaign Lead(s)*</label>
//                     {users.filter(user => user.role === 'Lead').map(user => (
//                         <label key={user._id} className="checkbox mr-3">
//                             <input
//                                 type="checkbox"
//                                 checked={user.isChecked || false}
//                                 onChange={handleCheckboxChange(user._id)}
//                             />
//                             <span className='ml-2'>{user.userName}</span>
//                         </label>
//                     ))}
//                 </div>

//                 <div className="field">
//                     <button
//                         className="button is-primary is-fullwidth mt-5 is-rounded"
//                         type="submit"
//                         disabled={loading}
//                     >
//                         {loading ? "Submitting..." : "Submit"}
//                     </button>
//                 </div>
//             </form>
//         </div>
//     );
// };

// export default CampaignForm;

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import { Config } from '../.env.js';
// import ReactQuill from 'react-quill';
// import 'react-quill/dist/quill.snow.css';

// const CampaignForm = () => {
//     const [AuthName, setAuthName] = useState('');
//     const [AuthContact, setAuthContact] = useState('');
//     const [AuthEmail, setAuthEmail] = useState('');
//     const [brandName, setBrandName] = useState('');
//     const [users, setUsers] = useState([]);
//     const [brandLogo, setBrandLogo] = useState(null);
//     const [brandLogoPreview, setBrandLogoPreview] = useState(null);

//     const [quillError, setQuillError] = useState(false);
//     const [loading, setLoading] = useState(false);
//     const navigate = useNavigate();

//     useEffect(() => {
//         const fetchUsers = async () => {
//             try {
//                 const response = await fetch(`${Config.API_URL}/api/getUsersmangerleads`);
//                 if (!response.ok) throw new Error('Failed to fetch users');
//                 const usersData = await response.json();
//                 console.log("Fetched users:", usersData); // 🟡 Add this line
//                 setUsers(usersData);
//             } catch (error) {
//                 console.error('Error fetching users:', error);
//             }
//         };

//         fetchUsers();
//     }, []);


//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);

//         const plainText = AuthEmail.replace(/<(.|\n)*?>/g, '').trim();
//         if (plainText.length === 0) {
//             setQuillError(true);
//             setLoading(false);
//             return;
//         }

//         const managers = users
//             .filter(user => user.role === 'Campaign_Manger' && user.isChecked && user.yourName)
//             .map(user => user.yourName);

//         const leads = users
//             .filter(user => user.role === 'Lead' && user.isChecked && user.yourName)
//             .map(user => user.yourName);

//         const formData = new FormData();
//         formData.append('brandName', brandName);
//         formData.append('name', AuthName);
//         formData.append('campaignName', AuthContact);
//         formData.append('campaignRulesDescription', AuthEmail);
//         formData.append('managers', JSON.stringify(managers));
//         formData.append('leads', JSON.stringify(leads));

//         if (brandLogo) {
//             formData.append('brandLogo', brandLogo);
//         }

//         try {
//             const response = await axios.post(`${Config.API_URL}/api/campaigns`, formData, {
//                 headers: { 'Content-Type': 'multipart/form-data' }
//             });

//             const { id } = response.data.campaign;
//             navigate('/campaign2', { state: { id, campaignName: AuthContact, managers } });
//         } catch (error) {
//             console.error('Error submitting form', error);
//         } finally {
//             setLoading(false);
//         }
//     };


//     // const handleCheckboxChange = (id) => (event) => {
//     //     const updatedUsers = users.map(user =>
//     //         user._id === id ? { ...user, isChecked: event.target.checked } : user
//     //     );
//     //     setUsers(updatedUsers);
//     //     localStorage.setItem('users', JSON.stringify(updatedUsers));
//     // };
//     const handleCheckboxChange = (id) => (event) => {
//         const updatedUsers = users.map(user =>
//             user._id === id ? { ...user, isChecked: event.target.checked } : user
//         );
//         console.log("Updated users:", updatedUsers); // 🟡 Add this
//         setUsers(updatedUsers);
//         localStorage.setItem('users', JSON.stringify(updatedUsers));
//     };

//     const isQuillContentEmpty = (content) => {
//         const plainText = content.replace(/<(.|\n)*?>/g, '').replace(/&nbsp;|\s/g, '').trim();
//         return plainText.length === 0;
//     };

//     const handleChange = (value) => {
//         setAuthEmail(value);
//         localStorage.setItem('AuthEmail', value);

//         if (!isQuillContentEmpty(value)) {
//             setQuillError(false);
//         }
//     };

//     // const handleChange = (value) => {
//     //     setAuthEmail(value);
//     //     localStorage.setItem('AuthEmail', value);
//     //     if (value.replace(/<(.|\n)*?>/g, '').trim().length > 0) {
//     //         setQuillError(false);
//     //     }
//     // };

//     const handleInputChange = (e, setter, storageKey) => {
//         const value = e.target.value;
//         setter(value);
//         localStorage.setItem(storageKey, value);
//     };

//     return (
//         <div className='container'>
//             {loading && (
//                 <div className="loader-overlay">
//                     <div className="loader"></div>
//                 </div>
//             )}
//             <form onSubmit={handleSubmit}>
//                 <div className="field">
//                     <h1 className='title has-text-centered mt-5'>Campaign</h1>
//                 </div>

//                 <div className='field is-small'>
//                     <label className="label has-text-left">Brand Name*</label>
//                     <div className="control">
//                         <input
//                             className="input is-rounded"
//                             type="text"
//                             placeholder="Brand Name"
//                             value={brandName}
//                             onChange={(e) => handleInputChange(e, setBrandName, 'brandName')}
//                             required
//                         />
//                     </div>
//                 </div>
//                 <div className="field is-small">
//                     <label className="label has-text-left">Brand Logo (600×600 max)*</label>
//                     <div className="control">
//                         <input
//                             className="input"
//                             type="file"
//                             accept="image/png, image/jpeg, image/jpg"
//                             onChange={(e) => {
//                                 const file = e.target.files[0];
//                                 if (file) {
//                                     setBrandLogo(file);
//                                     const reader = new FileReader();
//                                     reader.onloadend = () => {
//                                         setBrandLogoPreview(reader.result);
//                                     };
//                                     reader.readAsDataURL(file);
//                                 }
//                             }}
//                         />
//                     </div>
//                     {brandLogoPreview && (
//                         <div style={{ marginTop: "10px" }}>
//                             <p className="has-text-weight-semibold">Preview:</p>
//                             <img
//                                 src={brandLogoPreview}
//                                 alt="Brand Logo Preview"
//                                 style={{ maxWidth: "150px", maxHeight: "150px", border: "1px solid #ccc", borderRadius: "8px" }}
//                             />
//                         </div>
//                     )}
//                 </div>

//                 <div className='field is-small'>
//                     <label className="label has-text-left">Campaign Name*</label>
//                     <div className="control">
//                         <input
//                             className="input is-rounded"
//                             type="text"
//                             placeholder="Campaign Name"
//                             value={AuthContact}
//                             onChange={(e) => handleInputChange(e, setAuthContact, 'AuthContact')}
//                             required
//                         />
//                     </div>
//                 </div>

//                 <div className='field'>
//                     <label className="label has-text-left">Campaign Rules Description*</label>
//                     <div className="control">
//                         <ReactQuill
//                             value={AuthEmail}
//                             onChange={handleChange}
//                             placeholder="Campaign rule description"
//                             modules={{
//                                 toolbar: [
//                                     [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
//                                     [{ 'list': 'ordered' }, { 'list': 'bullet' }],
//                                     ['bold', 'italic', 'underline'],
//                                     [{ 'align': [] }],
//                                     ['link'],
//                                     ['blockquote'],
//                                     [{ 'script': 'sub' }, { 'script': 'super' }],
//                                     ['code'],
//                                     [{ 'indent': '-1' }, { 'indent': '+1' }],
//                                     ['clean']
//                                 ],
//                             }}
//                             style={{ borderRadius: "20px", border: quillError ? '1px solid red' : undefined }}
//                         />
//                         {quillError && (
//                             <p className="has-text-danger" style={{ fontSize: "0.85rem" }}>
//                                 Campaign rules description is required.
//                             </p>
//                         )}
//                     </div>
//                 </div>

//                 <div className='field'>
//                     <label className="label has-text-left"><strong>Choose Your Campaign Manager(s)</strong></label>
//                     <div className="control column">
//                         {users.filter(user => user.role === 'Campaign_Manger').map(user => (
//                             <div key={user._id} className="checkboxContainer" style={{ display: 'inline-flex', flexDirection: 'row', marginRight: '8px' }}>
//                                 <input
//                                     type="checkbox"
//                                     checked={user.isChecked || false}
//                                     onChange={handleCheckboxChange(user._id)}
//                                     className="checkbox"
//                                 />
//                                 <label className="checkboxLabel" style={{ marginLeft: '8px' }}>{user.yourName}</label>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 <div className='field'>
//                     <label className="label has-text-left"><strong>Choose Your Lead(s)</strong></label>
//                     <div className="control column">
//                         {users.filter(user => user.role === 'Lead').map(user => (
//                             <div key={user._id} className="checkboxContainer" style={{ display: 'inline-flex', flexDirection: 'row', marginRight: '9px' }}>
//                                 <input
//                                     type="checkbox"
//                                     checked={user.isChecked || false}
//                                     onChange={handleCheckboxChange(user._id)}
//                                     className="checkbox"
//                                 />
//                                 <label className="checkboxLabel" style={{ marginLeft: '8px' }}>{user.yourName}</label>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 <div className="field">
//                     <div className="control">
//                         <button className="button is-primary is-fullwidth mt-5 is-rounded" type="submit">
//                             {loading ? (
//                                 <div className="loader"></div>
//                             ) : (
//                                 'Submit'
//                             )}
//                         </button>
//                     </div>
//                 </div>
//             </form>
//         </div>
//     );
// };

// export default CampaignForm;

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import { Config } from '../.env.js';
// import ReactQuill from 'react-quill';
// import 'react-quill/dist/quill.snow.css';

// const CampaignForm = () => {
//     const [AuthName, setAuthName] = useState('');
//     const [AuthContact, setAuthContact] = useState('');
//     const [AuthEmail, setAuthEmail] = useState('');
//     const [brandName, setBrandName] = useState('');
//     const [reviewType, setReviewType] = useState('');
//     const [users, setUsers] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const navigate = useNavigate();

//     useEffect(() => {
//         const fetchUsers = async () => {
//             try {
//                 const response = await fetch(`${Config.API_URL}/api/users`);
//                 if (!response.ok) throw new Error('Failed to fetch users');
//                 const usersData = await response.json();
//                 setUsers(usersData);
//             } catch (error) {
//                 console.error('Error fetching users:', error);
//             }
//         };

//         fetchUsers();

//         // Load from localStorage
//         const savedBrandName = localStorage.getItem('brandName');
//         const savedAuthName = localStorage.getItem('AuthName');
//         const savedAuthContact = localStorage.getItem('AuthContact');
//         const savedAuthEmail = localStorage.getItem('AuthEmail');
//         const savedReviewType = localStorage.getItem('reviewType');
//         const savedUsers = JSON.parse(localStorage.getItem('users'));

//         if (savedBrandName) setBrandName(savedBrandName);
//         if (savedAuthName) setAuthName(savedAuthName);
//         if (savedAuthContact) setAuthContact(savedAuthContact);
//         if (savedAuthEmail) setAuthEmail(savedAuthEmail);
//         if (savedReviewType) setReviewType(savedReviewType);
//         if (savedUsers) setUsers(savedUsers);
//     }, []);

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);

//         const managers = users.filter(user => user.role !== 'Lead' && user.isChecked).map(user => user.userName);
//         const leads = users.filter(user => user.role === 'Lead' && user.isChecked).map(user => user.userName);

//         const formData = {
//             brandName,
//             name: AuthName,
//             campaignName: AuthContact,
//             campaignRulesDescription: AuthEmail,
//             managers,
//             leads,
//             reviewType
//         };

//         try {
//             const response = await axios.post(`${Config.API_URL}/api/campaigns`, formData);
//             const { id } = response.data.campaign;
//             navigate('/campaign2', { state: { id, campaignName: AuthContact, managers } });
//         } catch (error) {
//             console.error('Error submitting form', error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleCheckboxChange = (id) => (event) => {
//         const updatedUsers = users.map(user =>
//             user._id === id ? { ...user, isChecked: event.target.checked } : user
//         );
//         setUsers(updatedUsers);
//         localStorage.setItem('users', JSON.stringify(updatedUsers));
//     };

//     const handleChangeDescription = (value) => {
//         setAuthEmail(value);
//         localStorage.setItem('AuthEmail', value);
//     };

//     const handleInputChange = (e, setter, storageKey) => {
//         const value = e.target.value;
//         setter(value);
//         localStorage.setItem(storageKey, value);
//     };

//     return (
//         <div className='container'>
//             {loading && (
//                 <div className="loader-overlay">
//                     <div className="loader"></div>
//                 </div>
//             )}
//             <form onSubmit={handleSubmit}>
//                 <h1 className='title has-text-centered mt-5'>Create Campaign</h1>

//                 <div className='field'>
//                     <label className="label">Brand Name*</label>
//                     <div className="control">
//                         <input
//                             className="input is-rounded"
//                             type="text"
//                             placeholder="Brand Name"
//                             value={brandName}
//                             onChange={(e) => handleInputChange(e, setBrandName, 'brandName')}
//                             required
//                         />
//                     </div>
//                 </div>

//                 <div className='field'>
//                     <label className="label">Campaign Name*</label>
//                     <div className="control">
//                         <input
//                             className="input is-rounded"
//                             type="text"
//                             placeholder="Campaign Name"
//                             value={AuthContact}
//                             onChange={(e) => handleInputChange(e, setAuthContact, 'AuthContact')}
//                             required
//                         />
//                     </div>
//                 </div>

//                 <div className='field'>
//                     <label className="label">Campaign Rules Description*</label>
//                     <ReactQuill
//                         value={AuthEmail}
//                         onChange={handleChangeDescription}
//                         placeholder="Enter campaign rules"
//                         modules={{
//                             toolbar: [
//                                 [{ 'header': '1' }, { 'header': '2' }],
//                                 [{ 'list': 'ordered' }, { 'list': 'bullet' }],
//                                 ['bold', 'italic', 'underline'],
//                                 [{ 'align': [] }],
//                                 ['link'],
//                                 ['clean']
//                             ]
//                         }}
//                         style={{ borderRadius: "10px" }}
//                     />
//                 </div>

//                 <div className='field'>
//                     <label className="label">Review Type*</label>
//                     <div className="control">
//                         <div className="select is-rounded is-fullwidth">
//                             <select
//                                 name="reviewType"
//                                 value={reviewType}
//                                 onChange={(e) => {
//                                     setReviewType(e.target.value);
//                                     localStorage.setItem('reviewType', e.target.value);
//                                 }}
//                                 required
//                             >
//                                 <option value="">Select Review Type</option>
//                                 <option value="Google Review">Google Review</option>
//                                 <option value="Amazon Review">Amazon Review</option>
//                                 <option value="YouTube Review">YouTube Review</option>
//                             </select>
//                         </div>
//                     </div>
//                 </div>

//                 <div className='field'>
//                     <label className="label">Campaign Manager(s)*</label>
//                     {users.filter(user => user.role !== 'Lead').map(user => (
//                         <label key={user._id} className="checkbox mr-3">
//                             <input
//                                 type="checkbox"
//                                 checked={user.isChecked || false}
//                                 onChange={handleCheckboxChange(user._id)}
//                             />
//                             <span className='ml-2'>{user.userName}</span>
//                         </label>
//                     ))}
//                 </div>

//                 <div className='field'>
//                     <label className="label">Campaign Lead(s)*</label>
//                     {users.filter(user => user.role === 'Lead').map(user => (
//                         <label key={user._id} className="checkbox mr-3">
//                             <input
//                                 type="checkbox"
//                                 checked={user.isChecked || false}
//                                 onChange={handleCheckboxChange(user._id)}
//                             />
//                             <span className='ml-2'>{user.userName}</span>
//                         </label>
//                     ))}
//                 </div>

//                 <div className="field">
//                     <button
//                         className="button is-primary is-fullwidth mt-5 is-rounded"
//                         type="submit"
//                         disabled={loading}
//                     >
//                         {loading ? "Submitting..." : "Submit"}
//                     </button>
//                 </div>
//             </form>
//         </div>
//     );
// };

// export default CampaignForm;
